module.exports = __webpack_public_path__ + "img/Toba - KLP2.9163b9df.jpg";